import { normalizePlatformSessionId } from '@/common/utils/jsRequestSessionContext'
import type { ActionDependencies } from './types'

/**
 * sessionId для executeProcedure / elementAction: слот action (dialog/adjacent), не appStore.currentPageId.
 */
export function resolveActionPlatformSessionId(
  dependencies: ActionDependencies | undefined,
  resolveSlotId: (dependencies?: ActionDependencies) => string,
  fallbackFromCurrentPage: () => string | null,
): string | null {
  const slotId = String(resolveSlotId(dependencies) ?? '').trim()
  if (slotId && dependencies?.appStore?.pagesData?.[slotId]) {
    const fromSlot = normalizePlatformSessionId(
      dependencies.appStore.pagesData[slotId]?.sessionId,
    )
    if (fromSlot) return fromSlot
  }

  const fromInjectedPage = normalizePlatformSessionId(dependencies?.pageData?.sessionId)
  if (fromInjectedPage) return fromInjectedPage

  return fallbackFromCurrentPage()
}
